<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.base-dropdown-item {
  position: relative;
  display: block;
  text-align: left;
  line-height: 1.5;
  width: 100%;
  padding: 0.5rem;
  cursor: pointer;
  &:hover {
    background-color: $jps-gray-200;
  }
  &.base-dropdown-link {
    padding: 0;
    background-color: transparent;
    &:hover {
      background-color: $jps-gray-200;
    }

    :deep(> *) {
      padding: 0.375rem 1rem;
      display: block;
    }
  }
  &.base-dropdown-submenu {
    cursor: default;
    background-color: transparent;
    &:hover {
      background-color: transparent !important;
    }
  }
  &.base-dropdown-noclose {
    cursor: default;
    &:hover {
      background-color: transparent !important;
    }
  }
}
</style>

<template>
  <div
    class="base-dropdown-item"
    :class="{
      'base-dropdown-link': link,
      'base-dropdown-submenu': menu,
      'base-dropdown-noclose': noclose,
    }"
    @click="select"
    role="menuitem"
  >
    <slot :close="close" />
  </div>
</template>

<script lang="ts" setup>
interface Props {
  noclose?: boolean
  link?: boolean
  menu?: boolean
}

const emits = defineEmits(['click'])

const props = withDefaults(defineProps<Props>(), {
  noclose: false,
  link: false,
  menu: false,
})

const close = inject('close') as () => void

function select(e) {
  if (props.noclose) return
  close()
  emits('click')
}
</script>
